import React from 'react';
import rotarHorizontalImgsrc from '../../../static/img/rotate-to-landscape.gif';
import rotarVerticalImgSrc from '../../../static/img/rotate-to-portrait.gif';

export const IndicacionCamara = (props) => {
    const {vertical, mensajePantalla } = props;
    const img = vertical ? rotarVerticalImgSrc : rotarHorizontalImgsrc;
    const text = vertical ? "vertical" : "horizontal";

    return (
        <div className="gif-indicacion-orientacion">
            <img  src={img} className="rotar"/>
            { mensajePantalla ? 
                <span className="nueva-camara-texto">{mensajePantalla}</span>
                : <span className="nueva-camara-texto">Para tomar la foto, girá el teléfono a posición <b>{text}</b> y asegurate de que la cámara quede en formato apaisado.</span>
            }
        </div>
    );
}




// WEBPACK FOOTER //
// ./src/components/OnBoarding/customModals/IndicacionCamara.js